import Loading from './Loading'
const Fallback = () => {
	return(
		<Loading/>
	);   
}

export default Fallback;